import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import FiltrosInformesSeguimientoExtraccionesPool from '../../components/informes/FiltrosInformesSeguimientoExtraccionesPool'
import {obtenerInformeSeguimientoExtraccionesPool, obtenerRegistrosSeguimientosExtraccionesPool, imprimirPdfInformesSeguimientoExtraccionesPool, exportarInformeSeguimientoExtraccionesPool, abrirModalExportarImprimirInformesSeguimientoExtraccionesPool} from '../../actions/informes/informes'
import {comboVerraco, fetchComboPool, comboNombreGrupoVerraco, comboTipoDosis, comboIndex, comboRaza, comboLineaGenetica, comboOperario, comboTipoIntervencionSanitaria, comboCliente
  } from '../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
   ...state.informes,
   auth: state.auth,
   combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      obtenerInformeSeguimientoExtraccionesPool,
      obtenerRegistrosSeguimientosExtraccionesPool,
      comboVerraco,
      fetchComboPool,
      comboNombreGrupoVerraco,
      comboTipoDosis,
      comboIndex,
      comboRaza,
      comboLineaGenetica,
      comboOperario,
      comboTipoIntervencionSanitaria,
      comboCliente,
      exportarInformeSeguimientoExtraccionesPool,
      imprimirPdfInformesSeguimientoExtraccionesPool,
      abrirModalExportarImprimirInformesSeguimientoExtraccionesPool
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FiltrosInformesSeguimientoExtraccionesPool))